import type { SendAllPendingProgramInvitationsRequest } from '@coursera/grpc-types-enterpriseuser/coursera/proto/enterpriseuser/programinvitations/v1/program_invitations_api';

const PROGRAM_INVITATIONS_GRPC_ROOT = '/api/grpc/enterpriseuser/programinvitations/v1/ProgramInvitationsAPI';

export const resendAllInvitations = (programId: string) => {
  const request: SendAllPendingProgramInvitationsRequest = { programId };
  return fetch(`${PROGRAM_INVITATIONS_GRPC_ROOT}/SendAllPendingProgramInvitations`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
